import { Action, createReducer, on } from '@ngrx/store';
import { StateBuilder } from '../../../model/state.builder';
import { ExpenseActions } from './expense.actions';
import { IExpenseState } from './expense.state';

export const initialExpenseState: IExpenseState = {
  model: undefined,
  data: undefined,
  uiState: undefined
};

const expenseReducerFn = createReducer(
  initialExpenseState,
  on(ExpenseActions.reset, (state: IExpenseState, action) => {
    return new StateBuilder<IExpenseState>(initialExpenseState).build();
  }),
  on(ExpenseActions.load, (state: IExpenseState, action) => {
    return new StateBuilder<IExpenseState>(state).toLoading().build();
  }),
  on(ExpenseActions.loadSuccess, (state: IExpenseState, action) => {
    return new StateBuilder<IExpenseState>(state, action).toLoaded().build();
  }),
  on(ExpenseActions.submit, (state: IExpenseState, action) => {
    return new StateBuilder<IExpenseState>(state, action).toLoading().build();
  }),
  on(ExpenseActions.submitSuccess, (state: IExpenseState, action) => {
    return new StateBuilder<IExpenseState>(state, action).toLoaded().build();
  })
);

export function expenseReducer(state: IExpenseState | undefined, action: Action) {
  return expenseReducerFn(state, action);
}
